module.exports = __webpack_public_path__ + "img/ad_csx.a30850e5.png";